// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"cedf7fc2","195":"bfd7fabd","352":"cedf7fc2"}[chunkId] + ".chunk.css";
};